<template>
  <div class="flex justify-space-between gap-2">
    <p data-testid="title">
      {{ title }}
      <span v-if="titleRequired" class="text-[#206583]">*</span>
    </p>

    <div v-if="fetchingErrorMessage" class="flex align-center gap-2 align-center">
      <p class="text-secondary" data-testid="error-message">
        {{ fetchingErrorMessage }}
      </p>
      <VTooltip text="Try again!">
        <template #activator="{ props }">
          <VBtn
            v-bind="props"
            size="25"
            icon="refresh"
            variant="outlined"
            @click="emit('refetch')"
          />
        </template>
      </VTooltip>
    </div>
  </div>
</template>

<script setup lang="ts">
interface Props {
  title?: string
  titleRequired?: boolean
  fetchingErrorMessage?: string
}

interface Emit {
  (e: 'refetch'): void
}

defineProps<Props>()
const emit = defineEmits<Emit>()
</script>

<style scoped></style>
